import script from "./ChatbotTicino.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatbotTicino.vue?vue&type=script&setup=true&lang=js"

import "./ChatbotTicino.vue?vue&type=style&index=0&id=e5a90746&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5a90746"]])

export default __exports__